import { ChangeEvent } from "react";

// material-ui
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";

// project imports
import { useDispatch, useSelector } from "store";
import { editColumn } from "store/slices/kanban";

// types
import { ThemeMode } from "types/config";
import { KanbanColumn } from "types/kanban";

interface Props {
  column: KanbanColumn;
}

// ==============================|| KANBAN BOARD - COLUMN EDIT ||============================== //

const EditColumn = ({ column }: Props) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  // const { columns } = useSelector((state) => state.kanban);
  let columns = [
    {
      id: "column-1",
      title: "New",
      itemIds: ["3542", "8903", "1381"],
    },
    {
      id: "column-2",
      title: "Active",
      itemIds: ["6739", "3950", "6924"],
    },
    {
      id: "column-3",
      title: "Resolved",
      itemIds: ["4398"],
    },
    {
      id: "column-4",
      title: "Closed",
      itemIds: ["9589", "3410", "8679"],
    },
  ];

  const handleColumnRename = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      editColumn(
        {
          id: column.id,
          title: event.target.value,
          itemIds: column.itemIds,
        },
        columns
      )
    );
  };

  return (
    <OutlinedInput
      fullWidth
      value={column.title}
      onChange={handleColumnRename}
      sx={{
        mb: 1.5,
        "& input:focus": {
          bgcolor:
            theme.palette.mode === ThemeMode.DARK ? "dark.800" : "grey.50",
        },
        "& input:hover": {
          bgcolor:
            theme.palette.mode === ThemeMode.DARK ? "dark.800" : "grey.50",
        },
        "& input:hover + fieldset": {
          display: "block",
        },
        "&, & input": { bgcolor: "transparent" },
        "& fieldset": { display: "none" },
        "& input:focus + fieldset": { display: "block" },
      }}
      placeholder="title"
    />
  );
};

export default EditColumn;
